import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { LabourerContext } from '../../contexts/LabourerContext';
import ButtonLoader from '../ButtonLoader';

import resumeService from '../../services/resumeService';
import useResume from '../../hooks/useResume';

import { CheckBadgeIcon } from '@heroicons/react/20/solid';

const OnboardingResume = ({ isLoading, onSubmit }) => {
  const { labourer } = useContext(LabourerContext);

  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const { data, mutate } = useResume({ labourerId: labourer._id });
  const resume = data?.resume;

  const handleUpload = async () => {
    if (!file || isUploading) return;

    const resumeData = new FormData();
    resumeData.append('labourer', labourer._id);
    resumeData.append('file', file);

    try {
      setIsUploading(true);

      await resumeService.createResume({ resumeData });
      await mutate();

      setFile(null);
      toast.success('Resume uploaded');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'An error occurred while uploading the resume');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <p className='text-lg text-center mb-4'>
        Please upload your resume.
      </p>

      <div className='flex items-center justify-between border border-gray-300 rounded-md px-4 py-3 mb-4'>
        <p className='font-medium'>Resume</p>

        {resume ? (
          <CheckBadgeIcon className='h-8 w-8 text-green-500' />
        ) : (
          <div className='flex items-center gap-2'>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              id="resume_onboarding_input"
              className="block p-2 text-sm text-white rounded-lg cursor-pointer bg-ase-blue focus:outline-none ase-upload-input"
            />

            <button
              onClick={handleUpload}
              disabled={!file || isUploading}
              className='text-white bg-ase-blue font-medium text-sm px-4 py-2 rounded-md w-[80px] flex items-center justify-center disabled:opacity-50'
            >
              {isUploading ? <ButtonLoader /> : 'Upload'}
            </button>
          </div>
        )}
      </div>

      <button
        onClick={onSubmit}
        className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md flex items-center justify-center'
      >
        {isLoading ? <ButtonLoader /> : 'Finish'}
      </button>
    </>
  );
};

export default OnboardingResume;
